<template>
<div>
    <navbar id="nav">
  </navbar>
  <h3>Welcome to PsyCloud</h3>
  <div class="mx-4">
    <b-form @submit="onSubmit" v-if="show">
      <b-form-group>
        <b-row align-h="center" class="text-left">
          <b-col sm="1">
            <label for="input-first_name">First Name</label>
          </b-col>
          <b-col sm="4">
            <b-form-input
              id="input-first_name"
              v-model="form.first_name"
              required
              placeholder="Enter first name"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <br>
      <b-form-group>
        <b-row align-h="center" class="text-left">
          <b-col sm="1">
            <label for="input-last_name">Last Name</label>
          </b-col>
          <b-col sm="4">
            <b-form-input
              id="input-last_name"
              v-model="form.last_name"
              required
              placeholder="Enter last name"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <br>
      <b-form-group>
        <b-row align-h="center" class="text-left">
          <b-col sm="1">
            <label for="input-email">Email</label>
          </b-col>
          <b-col sm="4">
            <b-form-input
              id="input-email"
              v-model="form.email"
              type="email"
              required
              placeholder="Enter email"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <br>
      <b-button type="submit" class="rounded-pill" variant="info">Submit</b-button>
    </b-form>
  </div>
</div>
</template>

<script>
import axios from 'axios';
import Nav from './Nav.vue';

export default {
  name: 'Signup',
  data() {
    return {
      form: {
        first_name: '',
        last_name: '',
        email: '',
      },
      show: true,
      showMessage: false,
    };
  },
  components: {
    navbar: Nav,
  },
  methods: {
    signup(payload) {
      const path = `${this.$hostname}/submit-signup`;
      axios
        .post(path, payload)
        .then((res) => {
          if (res.data.status === 'success') {
            localStorage.userID = res.data.userID;
            localStorage.taskID = res.data.taskID;
            localStorage.first_name = res.data.first_name;
            this.$router.push({ name: 'Home' });
          } else if (res.data.status === 'existed') {
            this.message = 'User Existed';
            this.showMessage = true;
            this.initForm();
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
          this.message = 'Error';
          this.showMessage = true;
        });
    },
    initForm() {
      this.form.first_name = '';
      this.form.last_name = '';
      this.form.email = '';
      this.form.phone_number = '';
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.signup(this.form);
    },
  },
};
</script>
